import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class MemberByDisciplinaryPanel {

  constructor(private http: HttpClient) { }

  public getPanelsList(grantId):Observable<any> {
    let grantIdValue = grantId ? grantId : 0
    try {
      return this.http.get(environment.BASE_URL_HRD + 'tmMng/getRgaDisciplinaryCodeLabelValues/'
        + grantIdValue)
    }
    catch (exception) {
      console.log(exception)
    }

  }

  public getPanelMembersList(panelId, thematicPanelId):Observable<any> {
    try {
      return this.http.get(environment.BASE_URL_HRD + 'tmMng/getDisciplinaryPanelMember/'
        + panelId + '/' + thematicPanelId)
    }
    catch (exception) {
      console.log(exception)
    }
  }

  public getConditionalPanelMembers(categoryName, panelId, thematicPanelId):Observable<any> {
    try {
      return this.http.get(environment.BASE_URL_HRD + 'tmMng/getDisciplinaryPanelByCategoryAndId/'
        + categoryName + '/' + panelId + '/' + thematicPanelId)
    }
    catch (exception) {
      console.log(exception)

    }

  }

  public saveNewMemberDetails(payload):Observable<any> {
    try {
      return this.http.post(environment.BASE_URL_HRD +
        "tmMng/saveManagementDetail", payload)
    }
    catch (exception) {
      console.log(exception)

    }
  }

  public saveNewMemberDetailsJMP(payload):Observable<any> {
    if (payload.isPanelUpdated) {
      delete payload.isPanelUpdated
    }
    for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
      if (payload.rgaRoleViewDtoList[i].panelId) {
        payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId
        delete payload.rgaRoleViewDtoList[i].panelId
      }
      else {
        if (payload.rgaRoleViewDtoList[i].panelId == null) {
          delete payload.rgaRoleViewDtoList[i].panelId
        }
      }
    }
    if (payload.disciplinaryPanelId) {
      payload.addDisciplinaryPanel = true
    }
    else {
      payload.addDisciplinaryPanel = false
    }
    try {

      return this.http.post(environment.BASE_URL_HRD +
        "tmMng/saveJmpPanelMembers", payload)
    }
    catch (exception) {
      console.log(exception)

    }
  }

}
